import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ChunkHashAlgorithm } from '@atlaskit/media-core';
var hasher = null;
var sha256Hasher = null;
export var destroyHashers = function destroyHashers() {
  hasher = null;
  sha256Hasher = null;
};
export var createHasher = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(algorithm) {
    var _yield$import, _SimpleHasher, _yield$import2, SimpleHasher;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!(algorithm === ChunkHashAlgorithm.Sha256)) {
            _context.next = 9;
            break;
          }
          if (sha256Hasher) {
            _context.next = 8;
            break;
          }
          _context.next = 5;
          return import('./sha256SimpleHasher');
        case 5:
          _yield$import = _context.sent;
          _SimpleHasher = _yield$import.SimpleHasher;
          sha256Hasher = new _SimpleHasher();
        case 8:
          return _context.abrupt("return", sha256Hasher);
        case 9:
          _context.next = 13;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
        case 13:
          _context.next = 15;
          return import('./simpleHasher');
        case 15:
          _yield$import2 = _context.sent;
          SimpleHasher = _yield$import2.SimpleHasher;
          hasher = new SimpleHasher();
          return _context.abrupt("return", hasher);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  }));
  return function createHasher(_x) {
    return _ref.apply(this, arguments);
  };
}();